import type { SVGProps } from "react";
export interface Rocket01IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Rocket01Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Rocket01IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 16.972a2.87 2.87 0 0 0-1.59-2.57l-.787-.396a1.13 1.13 0 0 1-.623-1.007c0-5.266-2.465-8.136-4.053-9.45l-.305-.241a.825.825 0 0 0-.912-.08l-.122.08C9.93 4.49 7.125 7.382 7.125 12.999c0 .426-.241.816-.623 1.007l-.788.395a2.87 2.87 0 0 0-1.589 2.571v1.115l2.829-1.57.112-.055a1.124 1.124 0 0 1 1.502.683l.243.73h6.378l.243-.73.047-.117a1.125 1.125 0 0 1 1.567-.512l2.829 1.57zm2.25 2.178a1.626 1.626 0 0 1-2.209 1.518l-.205-.097-2.583-1.435a1.62 1.62 0 0 1-1.488.988H8.36a1.62 1.62 0 0 1-1.49-.988L4.29 20.57a1.625 1.625 0 0 1-2.415-1.42v-2.179a5.13 5.13 0 0 1 2.833-4.584l.18-.09c.227-6.054 3.354-9.35 5.231-10.78l.216-.151a3.08 3.08 0 0 1 3.546.15l.38.303c1.89 1.567 4.637 4.816 4.85 10.478l.181.09a5.13 5.13 0 0 1 2.833 4.584z"
      />
      <path
        fill={color}
        d="m15 20.875.116.006a1.125 1.125 0 0 1 0 2.239l-.116.005H9a1.125 1.125 0 0 1 0-2.25zm-3-13a2.126 2.126 0 1 1-2.114 2.342L9.875 10l.011-.218A2.125 2.125 0 0 1 12 7.875"
      />
    </svg>
  );
}
